<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('admin.name')}(ru) *`" v-model="form.name_ru"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('admin.name')}(uz) *`" v-model="form.name_uz"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="$t('admin.parent')" v-model="form.parent">
            <option v-for="department in relations.departments" :value="department.id">
              {{ department.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDateTime} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'

  const defaultData = {
    name_ru: '',
    name_uz: '',
    parent: null
  }

  export default {
    props: ['data', 'editMode'],
    components: {EmployeeSelect},
    data() {
      return {
        form: this.data || {...defaultData},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        let isValid = true
        this.errors = []
        if (this.form.name_ru === '' || this.form.name_uz === '') {
          this.errors.push(this.$t('interface.requiredFields'))
          isValid = false
        }
        return isValid
      },
      save() {
        if (this.validate()) {
          this.$emit('save', this.form)
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    computed: {
      ...mapState('Moderator', ['relations'])
    },
    watch: {
      data(data) {
        this.form = data
      }
    }
  }
</script>